import { Base } from "../../framework/base";
import { InstantMessageChannelItem } from "./instantMessageChannelItem";
var InstantMessageChannelItems = /** @class */ (function () {
    function InstantMessageChannelItems(obj) {
        this.channels = Base.getTypedArray(obj ? obj.channels : null, InstantMessageChannelItem);
    }
    return InstantMessageChannelItems;
}());
export { InstantMessageChannelItems };
